import type { TDescription } from "@/models/common.model"
import type { HttpClient } from "@/services/http-common"
import { tryCatch } from "@/lib/try-catch"
import { CompetitionStylesMapper } from "@/mappers/competition/competition.mapper"
import ApiServiceFactory from "@/services/api-service-factory"

export type TCompetitionStyles = {
  code: string
  description: TDescription
  order: number
}

export type TCategory = {
  code: string
  description: TDescription
  order: number
  discipline: string
}

export class CompetitionStyleService {
  private httpClient: HttpClient
  // private readonly baseUrl: string = "/competitions"

  constructor(httpClient: HttpClient) {
    this.httpClient = httpClient
  }

  async getCompetitionStyles(): Promise<TCompetitionStyles[]> {
    try {
      const response = await tryCatch(this.httpClient.get<TCompetitionStyles[]>(`competition-styles/get-all`))
      const { data, error } = response

      if (error) {
        if (error.statusCode === 404) {
          console.log("Competition not found")
          return []
        }
      }

      return CompetitionStylesMapper.toDto(data)
    }
    catch (error) {
      console.error("Error al obtener las competiciones:", error)
      return [] // Retornar array vacío en caso de error
    }
  }

  async getCategories(disciplineCode: string): Promise<TCategory[]> {
    try {
      const response = await tryCatch(this.httpClient.get<TCategory[]>(`categories/by-discipline/${disciplineCode}`))
      const { data, error } = response

      if (error) {
        if (error.statusCode === 404) {
          console.log("Competition not found")
          return []
        }
      }
      return data || []
    }
    catch (error) {
      console.error("Error al obtener las categorías:", error)
      return []
    }
  }
}

export const competitionStyleService = ApiServiceFactory.createService(CompetitionStyleService, "main")

export default CompetitionStyleService
